"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogItemListQuery = exports.updateCatalogItemRequest = exports.createCatalogItemRequest = exports.catalogItemDto = exports.catalogItemKind = exports.etaItemType = exports.salesNoteListQuery = exports.salesNoteDto = exports.salesNoteSummary = exports.createSalesNoteRequest = exports.salesNoteKind = exports.cancelSalesInvoiceRequest = exports.salesInvoiceListQuery = exports.salesInvoiceDto = exports.salesInvoiceCancellationDto = exports.salesInvoiceSummary = exports.salesInvoiceLineDto = exports.createSalesInvoiceRequest = exports.salesInvoiceLineInput = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
/** كمية بأربعة أرقام عشرية على الأكثر، موجبة — نص كالمال لا number. */
const quantityString = zod_1.z
    .string()
    .regex(/^\d{1,12}(\.\d{1,4})?$/, 'quantity must be a positive decimal string with up to 4 decimals')
    .refine((value) => /[1-9]/.test(value), 'quantity must be positive');
const nonNegativeMoney = common_1.moneyString.refine((value) => !value.startsWith('-'), 'amount cannot be negative');
/**
 * سطر فاتورة أو إشعار. مع `itemId` يُملأ ما غاب (البيان، السعر، حساب الإيراد، القاعدة
 * الضريبية) من صنف الكتالوج، وما أُرسل يعلو على الصنف — الصنف اقتراح لا قيد.
 * بلا صنف: البيان والسعر إلزاميان.
 */
exports.salesInvoiceLineInput = zod_1.z
    .object({
    itemId: common_1.uuid.optional(),
    description: zod_1.z.string().trim().min(1).max(500).optional(),
    quantity: quantityString,
    unitPrice: nonNegativeMoney.optional(),
    /** حساب الإيراد — إن غاب فحساب الصنف، وإلا حساب إيراد الخدمات الافتراضى للشركة. */
    revenueAccountCode: common_1.accountCode.optional(),
    /** قاعدة ضريبية معتمدة من إعدادات الشركة. بلا قاعدة = بلا ضريبة (BLOCKED-TAX). */
    taxRuleId: common_1.uuid.optional(),
})
    .strict()
    .superRefine((line, ctx) => {
    if (line.itemId)
        return;
    if (line.description === undefined) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['description'],
            message: 'description is required without an item',
        });
    }
    if (line.unitPrice === undefined) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['unitPrice'],
            message: 'unit price is required without an item',
        });
    }
});
/**
 * إصدار فاتورة خدمة آجلة. الخادم يسعّرها ويرحّلها فى نفس المعاملة: لا مسودات بعد،
 * والفاتورة المُصدرة لا تُعدَّل — التصحيح بإشعار دائن.
 */
exports.createSalesInvoiceRequest = zod_1.z
    .object({
    customerId: common_1.uuid,
    issueDate: common_1.isoDate,
    /** إن غاب: تاريخ الإصدار + مدة سداد العميل. */
    dueDate: common_1.isoDate.optional(),
    memo: zod_1.z.string().trim().max(500).optional(),
    lines: zod_1.z.array(exports.salesInvoiceLineInput).min(1).max(200),
})
    .strict();
exports.salesInvoiceLineDto = zod_1.z.object({
    lineNumber: zod_1.z.number().int(),
    itemId: common_1.uuid.nullable(),
    description: zod_1.z.string(),
    quantity: zod_1.z.string(),
    unitPrice: common_1.moneyString,
    revenueAccountCode: common_1.accountCode,
    net: common_1.moneyString,
    taxAmount: common_1.moneyString,
});
exports.salesInvoiceSummary = zod_1.z.object({
    id: common_1.uuid,
    companyId: common_1.uuid,
    number: zod_1.z.string(),
    customerId: common_1.uuid,
    customerName: zod_1.z.string(),
    issueDate: common_1.isoDate,
    dueDate: common_1.isoDate,
    currency: zod_1.z.string(),
    netTotal: common_1.moneyString,
    taxTotal: common_1.moneyString,
    total: common_1.moneyString,
    journalId: common_1.uuid,
    journalNumber: zod_1.z.string().nullable(),
    /** ما خُصص عليها من تحصيلات حتى الآن. */
    paid: common_1.moneyString,
    /** مجموع الإشعارات الدائنة المرتبطة بها (بالضريبة). */
    creditNotesTotal: common_1.moneyString,
    /** مجموع الإشعارات المدينة المرتبطة بها (بالضريبة). */
    debitNotesTotal: common_1.moneyString,
    /** `cancelled`: أُلغيت بقيد عكسى — تبقى مستندًا منشورًا برقمها ولا يُخصص عليها. */
    status: zod_1.z.enum(['posted', 'cancelled']),
    /** المتبقى = الإجمالى + المدينة − الدائنة − المخصص، وصفر للملغاة. */
    openBalance: common_1.moneyString,
});
exports.salesInvoiceCancellationDto = zod_1.z.object({
    cancellationDate: common_1.isoDate,
    reason: zod_1.z.string(),
    /** القيد العكسى — قيد الفاتورة الأصلى يبقى POSTED كما هو. */
    journalId: common_1.uuid,
    journalNumber: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
});
exports.salesInvoiceDto = exports.salesInvoiceSummary.extend({
    memo: zod_1.z.string().nullable(),
    lines: zod_1.z.array(exports.salesInvoiceLineDto),
    cancellation: exports.salesInvoiceCancellationDto.nullable(),
});
exports.salesInvoiceListQuery = zod_1.z
    .object({
    customerId: common_1.uuid.optional(),
    /** true: الفواتير التى عليها متبقٍ فقط — لشاشة التحصيل. */
    openOnly: zod_1.z.enum(['true', 'false']).optional(),
})
    .strict();
/**
 * إلغاء فاتورة بقيد عكسى كامل بتاريخ الإلغاء. يحكمه `settings.sales.invoiceCancellation`،
 * ويُرفض لفاتورة عليها تحصيل أو إشعار، أو بتاريخ فى فترة مقفلة.
 */
exports.cancelSalesInvoiceRequest = zod_1.z
    .object({
    cancellationDate: common_1.isoDate,
    reason: zod_1.z.string().trim().min(3).max(500),
})
    .strict();
/** دائن يخفض ذمة العميل (CN)، ومدين يزيدها (DN) — كلاهما على فاتورة منشورة. */
exports.salesNoteKind = zod_1.z.enum(['credit', 'debit']);
exports.createSalesNoteRequest = zod_1.z
    .object({
    kind: exports.salesNoteKind,
    invoiceId: common_1.uuid,
    noteDate: common_1.isoDate,
    reason: zod_1.z.string().trim().min(3).max(500),
    lines: zod_1.z.array(exports.salesInvoiceLineInput).min(1).max(200),
})
    .strict();
exports.salesNoteSummary = zod_1.z.object({
    id: common_1.uuid,
    companyId: common_1.uuid,
    kind: exports.salesNoteKind,
    number: zod_1.z.string(),
    invoiceId: common_1.uuid,
    invoiceNumber: zod_1.z.string(),
    customerId: common_1.uuid,
    customerName: zod_1.z.string(),
    noteDate: common_1.isoDate,
    reason: zod_1.z.string(),
    currency: zod_1.z.string(),
    netTotal: common_1.moneyString,
    taxTotal: common_1.moneyString,
    total: common_1.moneyString,
    journalId: common_1.uuid,
    journalNumber: zod_1.z.string().nullable(),
});
exports.salesNoteDto = exports.salesNoteSummary.extend({
    lines: zod_1.z.array(exports.salesInvoiceLineDto),
});
exports.salesNoteListQuery = zod_1.z
    .object({
    invoiceId: common_1.uuid.optional(),
    kind: exports.salesNoteKind.optional(),
})
    .strict();
/** نوع كود الصنف فى المنظومة. */
exports.etaItemType = zod_1.z.enum(['EGS', 'GS1']);
exports.catalogItemKind = zod_1.z.enum(['service', 'stock']);
/**
 * صنف أو خدمة فى الكتالوج. القيم الافتراضية تُنسخ إلى سطر الفاتورة وقت الإصدار —
 * تغيير الصنف لاحقًا لا يمس فاتورة صدرت.
 */
exports.catalogItemDto = zod_1.z.object({
    id: common_1.uuid,
    companyId: common_1.uuid,
    nameAr: zod_1.z.string(),
    unit: zod_1.z.string(),
    defaultPrice: common_1.moneyString,
    defaultTaxRuleId: common_1.uuid.nullable(),
    /** إن غاب: حساب إيراد الخدمات الافتراضى للشركة. */
    revenueAccountCode: common_1.accountCode.nullable(),
    /** كود الصنف فى منظومة الفاتورة الإلكترونية (EGS/GS1) — يُخزَّن ولا يُرسل بعد (BLOCKED-TAX). */
    etaItemCode: zod_1.z.string().nullable(),
    /** نوع الكود: EGS (كود داخلى مسجّل) أو GS1 (باركود عالمى). */
    etaItemType: exports.etaItemType.nullable(),
    /** كود وحدة القياس فى المنظومة (مثل EA). BLOCKED-TAX: القائمة من المنظومة لا من الكود. */
    etaUnitType: zod_1.z.string().nullable(),
    /** خدمة لا رصيد لها، أو صنف مخزنى تُتابع كميته وتكلفته (حين يكون المخزون مفعّلاً). */
    kind: exports.catalogItemKind,
    /** حساب المخزون (أصل) للصنف المخزنى — `null` للخدمة. */
    inventoryAccountCode: common_1.accountCode.nullable(),
    /** حساب تكلفة المبيعات للصنف المخزنى — `null` للخدمة. */
    cogsAccountCode: common_1.accountCode.nullable(),
    isActive: zod_1.z.boolean(),
    createdAt: zod_1.z.string(),
});
const optionalCode = (max) => zod_1.z
    .string()
    .trim()
    .max(max)
    .transform((value) => (value === '' ? null : value))
    .nullish();
exports.createCatalogItemRequest = zod_1.z
    .object({
    nameAr: zod_1.z.string().trim().min(2).max(200),
    unit: zod_1.z.string().trim().min(1).max(32),
    defaultPrice: nonNegativeMoney,
    defaultTaxRuleId: common_1.uuid.nullish(),
    revenueAccountCode: common_1.accountCode.nullish(),
    etaItemCode: optionalCode(64),
    etaItemType: exports.etaItemType.nullish(),
    etaUnitType: zod_1.z
        .string()
        .trim()
        .regex(/^[A-Za-z0-9]{0,16}$/, 'unit type is letters and digits')
        .transform((value) => (value === '' ? null : value.toUpperCase()))
        .nullish(),
    /** الافتراضى خدمة — كما كانت كل الأصناف قبل المخزون. */
    kind: exports.catalogItemKind.default('service'),
    /**
     * للصنف المخزنى فقط. إن غابا: حساب المخزون وتكلفة المبيعات من خريطة حسابات الشركة.
     * BLOCKED-ACCOUNTING: الحسابان الافتراضيان من قالب الدليل لا اعتماد محاسب.
     */
    inventoryAccountCode: common_1.accountCode.nullish(),
    cogsAccountCode: common_1.accountCode.nullish(),
})
    .strict();
/** التعديل كامل لا جزئى، والإيقاف بـ `isActive: false` — الصنف المستعمل لا يُحذف. */
exports.updateCatalogItemRequest = exports.createCatalogItemRequest
    .extend({ isActive: zod_1.z.boolean() })
    .strict();
exports.catalogItemListQuery = zod_1.z
    .object({
    /** true: الأصناف النشطة فقط — لاختيار الصنف فى سطر الفاتورة. */
    activeOnly: zod_1.z.enum(['true', 'false']).optional(),
})
    .strict();
//# sourceMappingURL=sales.js.map